// Generic textarea fallback for catalog items whose
// FormSchema is empty / blank.

import { Textarea, FormField } from "@/design-system/components/ui";
import type { JustificationData } from "@/lib/formSchema";

interface PopupFormGenericProps {
  value: JustificationData;
  onChange: (next: JustificationData) => void;
  disabled?: boolean;
}

export function PopupFormGeneric({ value, onChange, disabled }: PopupFormGenericProps) {
  const text =
    typeof value.__text === "string"
      ? (value.__text as string)
      : "";
  return (
    <FormField label="Justification / Notes">
      <Textarea
        rows={6}
        value={text}
        disabled={disabled}
        placeholder="Capture analyst rationale, key evidence references, calibration notes…"
        onChange={(e) => onChange({ ...value, __text: e.target.value })}
      />
    </FormField>
  );
}
